import { Controller } from "@hotwired/stimulus"
import { loadGoogleMaps } from "../google_maps_loader"
import { recordCostEvent } from "../cost_telemetry"

export default class extends Controller {
  static targets = ["button", "status"]
  static values = {
    apiKey: String,
    enabled: Boolean,
    initializer: String,
    context: String,
    autoload: Boolean
  }

  connect() {
    this.loading = false
    this.loaded = false
    if (this.autoloadValue) queueMicrotask(() => this.load())
  }

  load() {
    if (this.loading) return

    if (this.loaded) {
      this.initializeMap()
      return
    }

    recordCostEvent("map_intent", { context: this.contextValue })
    if (!this.enabledValue || !this.apiKeyValue) {
      this.showStatus("Interactive map unavailable. Please use the address or directions link.")
      recordCostEvent("map_error", { context: this.contextValue, reason: "disabled" })
      return
    }

    this.loading = true
    this.setButtonDisabled(true)
    this.showStatus("Loading interactive map…")

    loadGoogleMaps(this.apiKeyValue)
      .then(() => {
        recordCostEvent("map_script_loaded", { context: this.contextValue })
        this.initializeMap()
        this.loaded = true
        this.showStatus("")
        recordCostEvent("map_initialized", { context: this.contextValue })
      })
      .catch((error) => {
        this.showStatus("The interactive map could not be loaded. Please try again.")
        this.setButtonDisabled(false)
        this.showButton()
        recordCostEvent("map_error", { context: this.contextValue, reason: error.message })
      })
      .finally(() => {
        this.loading = false
      })
  }

  initializeMap() {
    const initializer = window[this.initializerValue]
    if (typeof initializer !== "function") throw new Error("Map initializer is unavailable")
    initializer()
  }

  setButtonDisabled(disabled) {
    if (this.hasButtonTarget) this.buttonTarget.disabled = disabled
  }

  showButton() {
    if (this.hasButtonTarget) this.buttonTarget.hidden = false
  }

  showStatus(message) {
    if (!this.hasStatusTarget) return

    this.statusTarget.textContent = message
    this.statusTarget.classList.toggle("hidden", !message)
  }
}
